import { Text } from 'react-gldn-kit';
import { useGetVipProgress } from 'react-render-hooks';
import LevelInfo from './components/LevelInfo';
import Benefits from './components/Benefits';

import { useZustandBalanceStore } from 'stores/user/balance/store';
import { getLoyaltyWagerSelector } from 'stores/user/balance/selectors';
import { useZustandUserStore } from 'stores/user/personal/store';
import { getUserCurrencyIdSelector } from 'stores/user/personal/selectors';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './BonusCabinet.module.css';
import GeneralBonuses from 'components/Alerts/Modal/components/Bonuses/components/GeneralBonuses';
import CashBonuses from './components/CashBonuses';
import VipBonuses from 'components/Alerts/Modal/components/Bonuses/components/VipBonuses';

const BonusCabinet = ({ withoutTitle = false }: { withoutTitle?: boolean }) => {
  const { level = { current: 0, next: 0 } } =
    useHookFabric<{
      level: { current: number; next: number };
      percent: number;
    }>({
      fn: useGetVipProgress,
      customProps: {},
    }) || {};

  return (
    <div className={styles.wrapperBonusCabinet}>
      {!withoutTitle && (
        <div className={styles.title}>
          <Text idT="bonusCabinet.title" />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.head}>
          <LevelInfo />

          <Benefits classes={styles.desktopOnly} />
        </div>

        <div className={styles.bonusCards}>
          <div className={styles.cardTitle}>
            <Text idT="bonusCabinet.available" />
          </div>

          <div className={styles.cards}>
            <GeneralBonuses />

            <CashBonuses />

            <VipBonuses />
          </div>
        </div>

        {!level.current && (
          <div className={styles.bonusCards}>
            <div className={styles.cardTitle}>
              <Text idT="bonusCabinet.unavailable" />
            </div>

            <div className={styles.cards}>
              <VipBonuses isAvailable={false} />
            </div>
          </div>
        )}

        <Benefits classes={styles.mobileOnly} />
      </div>
    </div>
  );
};

export default BonusCabinet;
